import { YearlyAccountingForecast } from './YearlyAccountingForecast';
import { GuidanceCycle } from './GuidanceCycle';

export class BudgetEntry extends YearlyAccountingForecast {
    public budgetId?: string;
    public yearCycle?: string;
    public guidanceCycle?: GuidanceCycle;
    public teamYearCycle?: string;
}
